import { Button, ButtonContainer, Card, Fieldset, FormHeading, Heading, Layout } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { newQuotationSliceActions } from '../newQuotation.slice';
import { AffordabilityDocumentUpload } from '../../../components/AffordabilityDocumentUpload/AffordabilityDocumentUpload';

export const AffordabilityDocumentUploadPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [uploadFields, setUploadFields] = useState<number[]>([0]);

  const onAddAnotherDocument = (fieldIndex: number) => {
    setUploadFields((currentFields: number[]) => {
      const isLastField = fieldIndex === currentFields.length - 1;

      if (!isLastField) {
        return currentFields;
      }

      return [...currentFields, currentFields.length];
    });
  };

  return (
    <>
      <Card title="">
        <Fieldset>
          <Fieldset.Row>
            <FormHeading>{t('affordabilityDocumentUploadPage:title')}</FormHeading>
          </Fieldset.Row>
          <Fieldset.Row>
            <Heading level={6} className="u-text-left">
              {t('affordabilityDocumentUploadPage:subtitle')}
            </Heading>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              {uploadFields.map((fieldIndex: number) => (
                <Layout.Item key={fieldIndex} default="1/1" className="u-mb">
                  <AffordabilityDocumentUpload
                    description={t('affordabilityDocumentUploadPage:documentUpload.description')}
                    supplementaryText={t('affordabilityDocumentUploadPage:documentUpload.supplementaryText')}
                    uploadButtonText={t('affordabilityDocumentUploadPage:documentUpload.uploadButtonText')}
                    accept={['.jpg', '.jpeg', '.pdf']}
                    onAddAnotherDocument={() => onAddAnotherDocument(fieldIndex)}
                  />
                </Layout.Item>
              ))}
            </Layout>
          </Fieldset.Row>
        </Fieldset>
      </Card>
      <Layout center className="u-mt">
        <ButtonContainer center>
          <Layout.Item default="1/4">
            <Button
              testId="button_goBack"
              secondary
              full
              onClick={() => {
                dispatch(newQuotationSliceActions.wizardPrevPage());
              }}
            >
              {t('usedCarFormSelectorPage:navigation.back')}
            </Button>
          </Layout.Item>

          <Layout.Item default="1/4">
            <Button
              testId="button_continue"
              full
              onClick={() => {
                dispatch(newQuotationSliceActions.wizardNextPage());
              }}
            >
              {t('usedCarFormSelectorPage:navigation.continue')}
            </Button>
          </Layout.Item>
        </ButtonContainer>
      </Layout>
    </>
  );
};
